// Closing Entry States

export default {
  closingEntryList: [],
  closingEntry: {}
}
